import {LeaderboardUser} from '@dms/api/settings';

export interface LeaderboardStats {
  sum: number;
  average: number;
  min: number;
  max: number;
}

/** Aggregate stats across the given users' totals (guarded for an empty list). */
export const getLeaderboardStats = (users: LeaderboardUser[]): LeaderboardStats => {
  if (users.length === 0) {
    return {sum: 0, average: 0, min: 0, max: 0};
  }

  const totals = users.map((user) => user.total);
  const sum = totals.reduce((accumulator, total) => accumulator + total, 0);

  return {
    sum,
    average: Math.round(sum / users.length),
    min: Math.min(...totals),
    max: Math.max(...totals),
  };
};
